import Modal from 'react-bootstrap/Modal';
import './LegalNoticesModal.css';

interface LegalNoticesModalProps {
  show: boolean;
  onHide: () => void;
}

function LegalNoticesModal({ show, onHide }: LegalNoticesModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      scrollable
      aria-labelledby="footer-legal-notices-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="footer-legal-notices-modal-title">Legal Notices</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="legal-notices-content">
          <section className="legal-section">
            <p>
              The terms and notices below, as amended by us from time to time, together with our
              Privacy Statement (collectively referred to as the &quot;Legal Notices&quot;), set out
              the basis on which you may use www.aosphere.com and important information about the
              way in which we provide our services, including details of our policy in relation to
              complaints.
            </p>
          </section>

          <section className="legal-section">
            <h2>1. About aosphere</h2>
            <p>
              aosphere Limited (&quot;aosphere&quot;) is a limited company registered in England and
              Wales with registered number 15371365 and registered office at The Steward Building,
              12 Steward Street, London E1 6FQ, United Kingdom.
            </p>
            <p>aosphere is registered for VAT purposes with VAT registration number GB 462 1046 24.</p>
          </section>

          <section className="legal-section">
            <h2>2. Terms of use of Website</h2>
            <h3>2.1 Access to the Website</h3>
            <p>
              www.aosphere.com (the &quot;Website&quot;) is provided by aosphere (also referred to
              as &quot;we&quot; or &quot;us&quot; in these terms of use). These terms of use are the
              terms and conditions on which we provide the test, software, database, format,
              documents, graphic and written work and all other materials published on the Website
              (the &quot;Content&quot;). Your use of the Content is governed by these terms, and the terms and conditions set out in your individual subscription agreement. By using the
              Website you accept these terms.
            </p>
            <p>The Website is for your own private use. By accessing the Website, you agree:</p>
            <ul>
              <li>not to use the Website or the Content in contravention of any regulation or legislation;</li>
              <li>
                not to copy, print, amend, reproduce or distribute the Content, or disclose the Content to
                third parties, other than in compliance with our Copyright Notice;
              </li>
              <li>
                not to advertise or sell any goods or services to other users of the Website or to
                benefit commercially from the Content; and
              </li>
              <li>
                that you are responsible for any material you send to or upload to the Website and
                that such material is legal, is not offensive and does not infringe our rights,
                those of third parties or the provisions of the Legal Notices.
              </li>
            </ul>
            <p>
              Where you have access to any of our services at www.aoslogin.com, your access to, and
              use of, those services is subject to certain conditions of use as described on the
              log-in page on that website.
            </p>

            <h3>2.2 Intellectual Property Rights</h3>
            <p>
              We, our suppliers or third parties who have granted us permission to reproduce their
              material on the Website own all trade marks, copyright and all other intellectual
              property rights in the Content and the Website. Nothing in the Legal Notices gives you
              any right, title or interest in the Content or the Website.
            </p>

            <h3>2.3 Limitations and Exclusions of our Liability</h3>
            <p>
              The Website and the Content are provided for general information purposes only and
              nothing on the Website or in the Content is intended to provide legal or other
              professional advice. We do not accept any responsibility for any loss which may arise
              from reliance on information or materials published on the Website.
            </p>
            <p>
              We are not responsible or liable for any matter relating to you or any third parties
              accessing or using the Website and the Content.
            </p>
            <p>
              We do not endorse nor are we responsible for the contents of websites operated by
              others that link to the Website or that are accessible from it.
            </p>
            <p>
              We do not guarantee that our Website will be secure or free from bugs or viruses. You
              are responsible for configuring your information technology, computer programs and
              platform to access our Website. You should use your own virus protection software.
            </p>
            <p>
              Nothing in these terms of use excludes or limits our liability for fraud or for death
              or personal injury arising from our negligence or for any other matter in respect of
              which it would be unlawful or in breach of regulation to limit or exclude liability.
            </p>

            <h3>2.4 Online Privacy</h3>
            <p>
              Our online Privacy Statement forms part of the Legal Notices and therefore the terms
              on which we provide and allow access to the Website. You acknowledge that we may
              process the personal information you provide if you use the Website in accordance with
              our online Privacy Statement.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. General Provisions</h2>
            <h3>3.1 Enforceability and waiver</h3>
            <p>Our rights under the Legal Notices may be waived only in writing and specifically.</p>
            <p>
              If a provision of the Legal Notices is or becomes illegal, invalid or unenforceable in
              any jurisdiction, that does not affect the legality, validity or enforceability in
              that jurisdiction of any other provision of the Legal Notices, or in other
              jurisdictions of the Legal Notices.
            </p>
            <h3>3.2 Changes to the Legal Notices</h3>
            <p>
              The Legal Notices may be amended by us at any time. Please check the Website
              periodically to inform yourself of any changes.
            </p>
            <h3>3.3 Governing Law</h3>
            <p>
              The Legal Notices shall be governed by and interpreted in accordance with English law
              and we and you each submit irrevocably to the exclusive jurisdiction of the English
              Courts.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Copyright Notice</h2>
            <p>© aosphere Limited 2025. All rights reserved.</p>
            <p>
              Copyright in some documents and material available on the Website may belong to third
              parties and such documents and material have been produced on the Website with the
              permission of the third-party copyright owners.
            </p>
            <p>
              With the exception of copyright belonging to third parties and unless otherwise stated,
              copyright in the pages of the Website and all other material available through it
              belongs to aosphere.
            </p>
            <p>
              Except where the law explicitly provides otherwise, any reproduction, transmission, printing or storing of all or part of the Website, the Content and/or any of the materials available through it, in any medium, without the prior written consent of aosphere, is expressly forbidden.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Regulation and Insurance</h2>
            <p>
              aosphere does not provide legal advice and is not regulated by the Solicitors
              Regulation Authority of England &amp; Wales (the &quot;SRA&quot;), although some
              aosphere content and activities may be provided by individuals who are individually
              regulated by the SRA.
            </p>
            <p>
              We have professional indemnity insurance led by CFC Underwriting Limited, authorised
              and regulated by the Financial Conduct Authority (No. 312848), supported by other
              major insurance companies and Lloyds syndicates.
            </p>
            <p>
              Further details of our professional indemnity insurance may be obtained from aosphere{' '}
              (<a href="mailto:info@aosphere.com" target="_self">info@aosphere.com</a>).
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Complaints</h2>
            <p>
              aosphere is committed to providing the highest quality of service. If you are
              dissatisfied with any aspect of the service provided to you, we ask that in the first
              instance you contact us. If you are still dissatisfied, you are entitled to invoke our
              complaints process, a copy of which may be obtained from aosphere{' '}
              (<a href="mailto:info@aosphere.com" target="_self">info@aosphere.com</a>).
            </p>
            <p>
              If you have a complaint about an individual who is individually regulated by the SRA,
              you may be entitled to ask the SRA or the Legal Ombudsman of England and Wales to
              consider your complaint.
            </p>
            <p>
              Legal Ombudsman details are available at{' '}
              <a href="https://www.legalombudsman.org.uk/" target="_blank" rel="noreferrer">
                https://www.legalombudsman.org.uk/
              </a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. No text or data mining, or web scraping</h2>
            <p>
              We do not permit any text or data mining or web scraping in relation to our Website or
              Content or any services provided in relation to our Website, for any purpose.
            </p>
            <p>
              You must not use our Website or Content or any services provided in relation to our
              Website for the purposes of developing, training or validating any AI system or model.
            </p>
            <p>
              This restriction will not apply to the extent that we are unable to exclude or limit
              text or data mining or web scraping activity under applicable law.
            </p>
          </section>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default LegalNoticesModal;
